import { ChangeDetectionStrategy, Component, effect, inject, signal } from '@angular/core'
import { LoadingService } from '@isl-core/services/loading.service'
import { ProgressBarModule } from 'primeng/progressbar'

@Component({
    selector: 'app-block-ui',
    imports: [ProgressBarModule],
    standalone: true,
    templateUrl: './block-ui.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BlockUiComponent {
    private loadingService = inject(LoadingService)

    isLoading = signal(false)
    shouldBlockUI = signal(true)
    color = '#216d61'
    backgroundColor = '#7a9b94'

    constructor() {
        effect(() => {
            this.isLoading.set(this.loadingService.get()())
            this.shouldBlockUI.set(this.loadingService.getShouldBlockUI())
        })
    }
}
